import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from '../Icon';
import styles from './Button.module.css';
export function Button(props) {
    const { dataTestId, variant, size, leftIcon, rightIcon, children, className, disabled, onClick, ...rest } = props;
    const getVariantStyle = () => {
        switch (variant) {
            case 'primary':
                return styles.primary;
            case 'secondary':
                return styles.secondary;
            case 'tertiary':
                return styles.tertiary;
            case 'outline':
                return styles.outline;
            default:
                return styles.primary;
        }
    };
    const variantStyle = getVariantStyle();
    const mediumOrLargeSize = size === 'medium' ? styles.medium : styles.large;
    const sizeStyle = size === 'small' ? styles.small : mediumOrLargeSize;
    return (_jsxs("button", { ...rest, className: [styles.container, styles.label, variantStyle, sizeStyle, className].join(' '), "data-testid": dataTestId, disabled: disabled, onClick: disabled ? undefined : onClick, children: [leftIcon && (_jsx(Icon, { name: leftIcon, className: styles.icon, alt: 'Left indicator', "aria-hidden": 'true', "data-testid": `img-${dataTestId}-left-icon` })), children, rightIcon && (_jsx(Icon, { name: rightIcon, alt: 'Right indicator', "aria-hidden": 'true', className: styles.icon, "data-testid": `img-${dataTestId}-right-icon` }))] }));
}
